import React, { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import IUserProfileReducer from '../../../interfaces/reducers/userProfileReducer';
import { IStore } from '../../../reducers';
import { Columns } from '../../base/grid';
import OnboardingSteps from './onboardingSteps';
import StepDelivery from './stepDelivery';
import StepNotifications from './stepNotifications';
import StepPayment from './stepPayment';
import StepProfile from './stepProfile';

interface Props {}

const Onboarding: FC<Props> = () => {
	const userProfileReducer: IUserProfileReducer = useSelector<IStore, IUserProfileReducer>(
		store => store.userProfileReducer
	);
	const { userProfile } = userProfileReducer;
	const [newUserProfile, setNewUserProfile] = useState(userProfile);
	const { t } = useTranslation('myShipments');
	const lastStep = 3;
	const [active, setActive] = useState(
		Math.min(Number(window.sessionStorage.getItem('onboardingTab') || 0), lastStep)
	);

	const handleProceed = useCallback(() => {
		window.sessionStorage.setItem('onboardingTab', String(active + 1));
		setActive(active + 1);
	}, [active]);

	return (
		<Columns>
			{{
				0: <StepNotifications Proceed={handleProceed} />,
				1: (
					<StepProfile
						Proceed={handleProceed}
						NewUserProfile={newUserProfile}
						SetNewUserProfile={setNewUserProfile}
					/>
				),
				2: (
					<StepPayment
						Proceed={handleProceed}
						NewUserProfile={newUserProfile}
						SetNewUserProfile={setNewUserProfile}
					/>
				),
				3: <StepDelivery NewUserProfile={newUserProfile} />,
			}[active] || <StepDelivery NewUserProfile={newUserProfile} />}
			<OnboardingSteps
				active={active}
				setActive={setActive}
				steps={[
					{ heading: t('onboarding.terms.bubbleHeading'), details: t('onboarding.terms.bubbleText') },
					{ heading: t('onboarding.profile.bubbleHeading'), details: t('onboarding.profile.bubbleText') },
					{ heading: t('onboarding.payment.bubbleHeading'), details: t('onboarding.payment.bubbleText') },
					{ heading: t('onboarding.delivery.bubbleHeading'), details: t('onboarding.delivery.bubbleText') },
				]}
			/>
		</Columns>
	);
};

export default Onboarding;
